module.exports = __webpack_public_path__ + "img/horizontal_7_5_8011.915789b9.png";